import React from 'react';
import { string } from 'prop-types';
import { SignIn as SignInComponent } from '@thd-olt-component-react/sign-in';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function SignIn({ id }) {

  return (
    <ErrorBoundary name="sign-in">
      <QueryProvider cacheKey="sign-in">
        <div
          id="signIn-php"
          className="sui-h-full"
        >
          <SignInComponent
            schema="pers_signInCard"
            componentId={id}
          />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}

SignIn.propTypes = {
  id: string,
};

SignIn.defaultProps = {
  id: undefined,
};